import { ChevronRightIcon } from '@heroicons/react/24/outline';
import Link from 'components/gruenland/atoms/link';
import Typography from 'components/gruenland/atoms/typography';
import { Category } from 'types/entity/category';

export interface Props {
  link: Category;
  onClick: () => void;
  hideHeaderMenu: () => void;
}

const MobileMenuNavButton: React.FC<Props> = ({ link, onClick, hideHeaderMenu }) => {
  return (
    <div key={link.categoryId}>
      {link?.descendants && link?.descendants?.length > 0 ? (
        <button onClick={onClick} className="flex w-full justify-between py-4">
          <Typography className="font-medium text-primary-black">{link.name}</Typography>
          <ChevronRightIcon className="w-5 text-secondary-black" />
        </button>
      ) : (
        <button onClick={hideHeaderMenu} className="flex w-full justify-between py-4">
          <Link link={link?._url}>
            <Typography className="font-medium text-primary-black">{link.name}</Typography>
          </Link>
        </button>
      )}
    </div>
  );
};

export default MobileMenuNavButton;
